export default __webpack_public_path__ + "static/media/Brain_Informatics.8a941394.webp";